import type { LifecycleState, BillingStatus } from '../api/client';

const LIFECYCLE_STYLES: Record<LifecycleState, string> = {
  PENDING: 'bg-warn/15 text-warn',
  ACTIVE: 'bg-good/15 text-good',
  SUSPENDED: 'bg-bad/15 text-bad',
  ARCHIVED: 'bg-ink-muted/15 text-ink-muted',
  OFFBOARDED: 'bg-ink-muted/15 text-ink-muted',
  DELETED: 'bg-ink-muted/15 text-ink-muted line-through',
};

const BILLING_STYLES: Record<BillingStatus, string> = {
  PENDING: 'bg-warn/15 text-warn',
  ACTIVE: 'bg-good/15 text-good',
  PAST_DUE: 'bg-bad/15 text-bad',
  CANCELLED: 'bg-ink-muted/15 text-ink-muted',
};

export function LifecycleBadge({ state }: { state: LifecycleState }) {
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium uppercase tracking-wider ${LIFECYCLE_STYLES[state]}`}>
      {state.toLowerCase()}
    </span>
  );
}

export function BillingBadge({ status }: { status: BillingStatus }) {
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium uppercase tracking-wider ${BILLING_STYLES[status]}`}>
      {status.toLowerCase().replace('_', ' ')}
    </span>
  );
}
